import { IStatMap } from "../contracts/StatMap";
import {
  IBillingInfo,
  IUtilityMetric,
  IUtilityMetricsRequest,
  IUtilityRequest,
  UapiManualSaveRequest,
  UapiManualSaveResponse,
  UtilityMetricsMapType,
} from "../contracts/Uitility";
import { IUtilityCompanyResponse } from "../contracts/UtilityCompany";
import {
  IServingUtilityProposal,
  IServingUtilityProposalRequest,
} from "../contracts/ServingUtility";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync, putDataAsync } from "../ZeosApiExecutor";
import { IUtility } from "./interfaces/IUtility";

const prefix = "/utility/";

export const Utility: IUtility = {
  manualSaveAsync: async (
    zeosUserId: number,
    req: UapiManualSaveRequest
  ): Promise<IZeosApiResponse<UapiManualSaveResponse>> => {
    return await postDataAsync<UapiManualSaveResponse>(
      `${prefix}manual/${zeosUserId}`,
      req
    );
  },
  manualUpdateAsync: async (
    zeosUserId: number,
    uapiManualId: number,
    req: UapiManualSaveRequest
  ): Promise<IZeosApiResponse<UapiManualSaveResponse>> => {
    return await putDataAsync<UapiManualSaveResponse>(
      `${prefix}manual/${zeosUserId}/${uapiManualId}`,
      req
    );
  },
  getBillingInfo: async (req: IUtilityRequest) => {
    return await postDataAsync<IBillingInfo[]>(`${prefix}billingInfo`, req);
  },
  getDashboardData: async () => {
    return await getDataAsync<IUtilityMetric[]>(
      `${prefix}dashboardData`,
      "data"
    );
  },
  getBuildingStats: async (): Promise<IZeosApiResponse<IStatMap>> => {
    return await getDataAsync<IStatMap>(`${prefix}dashboardData`, "data");
  },
  utilityMetrics: async (req: IUtilityMetricsRequest) => {
    return await postDataAsync<UtilityMetricsMapType>(
      `${prefix}utilityMetrics`,
      req
    );
  },
  getCompaniesAsync: async (
    stateCode?: string
  ): Promise<IZeosApiResponse<IUtilityCompanyResponse[]>> => {
    const query = stateCode ? `?stateCode=${encodeURIComponent(stateCode)}` : "";
    return await getDataAsync<IUtilityCompanyResponse[]>(
      `${prefix}companies${query}`,
      "data"
    );
  },
  proposeServingUtilitiesAsync: async (
    request: IServingUtilityProposalRequest
  ): Promise<IZeosApiResponse<IServingUtilityProposal>> => {
    const params = new URLSearchParams();
    if (request.zip) params.set("zip", request.zip);
    if (request.city) params.set("city", request.city);
    if (request.state) params.set("state", request.state);
    if (request.address) params.set("address", request.address);
    const query = params.toString() ? `?${params.toString()}` : "";
    return await getDataAsync<IServingUtilityProposal>(
      `${prefix}territory${query}`,
      "data"
    );
  },
};
